var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"notificatorModal",attrs:{"height":"auto","scrollable":true,"resizable":true,"adaptive":true,"width":"1366px","name":"snapshot-modal"},on:{"before-open":_vm.beforeOpen}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imageHost + "/" + _vm.check_id + ".png"),expression:"imageHost + \"/\" + check_id + \".png\""}]})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29340f46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SnapshotModal.vue
// module id = 9FUE
// module chunks = 1